import { styled } from "@mui/system";
import { IconButton } from "@mui/material";
import COLORS from "../../../theme/Colors";

export const Container = styled("div")({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: COLORS.primary,
  
});

export const CenterContainer = styled("div")({
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "16px 64px 16px 64px",
  color: "white",
  "@media (min-width:320px)": {
    flexDirection: "column",
  },
  "@media (min-width:768px)": {
    flexDirection: "row",
  },
});

export const LogoImage = styled("img")({
  objectFit: "cover",
});

export const SocialNetworkContainer = styled("div")({
  flexDirection: "row",
  gap: 8,
  display: "flex",
});
